import { render, staticRenderFns } from "./BarChartCardTonsByCertification.vue?vue&type=template&id=26d37c69&"
import script from "./BarChartCardTonsByCertification.vue?vue&type=script&lang=js&"
export * from "./BarChartCardTonsByCertification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports